import { Routes } from '@angular/router';
import { authGuard } from '../core/guards/auth.guard';
import { MainLayoutComponent } from '../layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Login',
    loadComponent: () =>
      import('../features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () =>
          import('../features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'orders-partner/active',
        title: 'Active Orders',
        loadComponent: () =>
          import('../features/orders-partner/active-orders/active-orders.component').then(
            (m) => m.ActiveOrdersComponent
          ),
      },
      {
        path: 'orders-partner/completed',
        title: 'Completed Orders',
        loadComponent: () =>
          import('../features/orders-partner/completed-orders/completed-orders.component').then(
            (m) => m.CompletedOrdersComponent
          ),
      },
      {
        path: 'orders-partner/returned',
        title: 'Returned Orders',
        loadComponent: () =>
          import('../features/orders-partner/returned-orders/returned-orders.component').then(
            (m) => m.ReturnedOrdersComponent
          ),
      },
      {
        path: 'orders-partner/closed',
        title: 'Rejected & Cancelled Orders',
        loadComponent: () =>
          import('../features/orders-partner/closed-orders/closed-orders.component').then(
            (m) => m.ClosedOrdersComponent
          ),
      },
      {
        path: 'orders-partner/detail/:id',
        title: 'Order Detail',
        loadComponent: () =>
          import('../features/orders-partner/order-detail/order-detail.component').then(
            (m) => m.OrderDetailComponent
          ),
      },
      {
        path: 'orders-partner/return-detail/:id',
        title: 'Return Order Detail',
        loadComponent: () =>
          import('../features/orders-partner/return-order-detail/return-order-detail.component').then(
            (m) => m.ReturnOrderDetailComponent
          ),
      },
      {
        path: 'settlement',
        title: 'Settlement',
        loadComponent: () =>
          import('../features/settlement/settlement.component').then(
            (m) => m.SettlementComponent
          ),
      },
      {
        path: 'settings/zip-codes',
        title: 'Serviceable Zip Codes',
        loadComponent: () =>
          import(
            '../features/settings/warehouse-zipcodes/warehouse-zipcodes.component'
          ).then((m) => m.WarehouseZipCodesComponent),
      },
      {
        path: 'settings/store-timings',
        title: 'Store Timings',
        loadComponent: () =>
          import('../features/settings/store-timings/store-timings.component').then(
            (m) => m.StoreTimingsComponent
          ),
      },
      {
        path: 'top-products',
        title: 'Top Selling Products',
        loadComponent: () =>
          import('../features/top-products/top-products.component').then(
            (m) => m.TopProductsComponent
          ),
      },
      {
        path: 'bounce-products',
        title: 'Bounced Products',
        loadComponent: () =>
          import('../features/bounce-products/bounce-products.component').then(
            (m) => m.BounceProductsComponent
          ),
      },
      {
        path: 'product-mapping',
        title: 'Product Mapping',
        loadComponent: () =>
          import('../features/product-mapping/product-mapping.component').then(
            (m) => m.ProductMappingComponent
          ),
      },
      {
        path: 'product-pricing',
        title: 'Product Pricing',
        loadComponent: () =>
          import('../features/product-pricing/product-pricing.component').then(
            (m) => m.ProductPricingComponent
          ),
      },
      {
        path: '**',
        redirectTo: 'orders-partner/active',
      },
    ],
  },
];
